import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './app.state';
import { routerReducer } from '@ngrx/router-store';
import { userProfile } from './core/reducers/userProfile.reducer';
import { messages } from './core/reducers/messages.reducer';
import { loadingStatus } from './reducers/loading-status.reducer';
import { loadingError } from './reducers/loading-error.reducer';

/**
 * App store.
 *
 * https://github.com/ngrx/platform/blob/master/docs/router-store/api.md#navigation-actions
 */
export const reducers: ActionReducerMap<AppState> = {
    routerReducer,
    userProfile,
    messages,
    loadingStatus,
    loadingError
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/app.store.ts